{
  "responseShape": "Server response did not match the expected shape — please refresh.",
  "badRequest": "Invalid request. Please check your input.",
  "forbidden": "You do not have permission to perform this action.",
  "facilityRequired": "Pick a facility in the header to use this module.",
  "notFound": "Resource not found.",
  "conflict": "Resource already exists.",
  "validation": "Validation error.",
  "tooManyRequests": "Too many requests. Please try again later.",
  "serverError": "Server error. Please try again later.",
  "unexpected": "An unexpected error occurred.",
  "network": "Network error. Please check your connection.",
  "requestSetup": "An error occurred. Please try again.",
  "sessionExpired": "Your session has expired. Please log in again."
}
